<template>
  <v-app>
    <Navbar />
    <NotificationList />
    <v-main class="pt-2">
      <router-view></router-view>
    </v-main>
    <modalBuyTokens />
    <BuyConfirmation />
    <Footer />
    <OnboardingV2 v-if="showOnboarding"/>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Navbar from "@/components/Navbar";
import NotificationList from "@/components/NotificationList.vue";
import Footer from "@/components/Footer";
import OnboardingV2 from "@/components/OnboardingV2.vue";
import modalBuyTokens from "@/components/modalBuyTokens";
import BuyConfirmation from "@/components/BuyConfirmation";


export default {
  name: "App",
  components: {
    modalBuyTokens,
    BuyConfirmation,
    Navbar,
    NotificationList,
    Footer,
    OnboardingV2,
  },
  computed: {
    ...mapState([
    "user",
    "isAuthenticated",
    "loading",
    "hasNickname"
    ]),
    ...mapGetters([
      "showOnboarding"
    ]),
  },
  methods: {
    // inject lucky orange script in production env
    loadLuckyOrange: () => {
      if (process.env.NODE_ENV === "production") {
        window.__lo_site_id = 246087;
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://d10lpsik1i8c69.cloudfront.net/w.js";
        document.head.appendChild(script);
      }
    },
  },
  beforeMount() {
    this.loadLuckyOrange();
  },
  created() {
    if (this.$route.query && this.$route.query.referral_inviter != null) {
      this.$store.dispatch("SetReferral", this.$route.query.referral_inviter);
    }
  },
  beforeUpdate() {
    this.$store.dispatch("FetchUser");
  },
  beforeDestroy() {
    this.$store.dispatch("ResetStore");
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Grenze:ital,wght@0,300;0,400;0,900;1,300;1,400;1,900&family=Montserrat&display=swap");
</style>
